import styled, { keyframes } from "styled-components";
import { colours } from "../../../../styles/colours.constants";
import { satoshi700 } from "../../../../styles/font.constants";

const pulse = keyframes`
  from {
    opacity: 0.2;
  }
  to {
    opacity: 1;
  }
`;

export const LiveStatus = styled.div`
	display: flex;
	align-items: center;
	gap: 0.4rem;
`;

export const LiveIndicator = styled.div`
	position: relative;
	width: 32px;
	height: 32px;
`;

export const IndicatorBorder = styled.div`
	position: absolute;
	width: 32px;
	height: 32px;
	border: solid 7px ${colours.red}50;
	border-radius: 16px;
	animation: ${pulse} 1.2s ease-in-out infinite alternate;
`;

export const IndicatorCenter = styled.div`
	position: absolute;
	width: 18px;
	height: 18px;
	left: 7px;
	top: 7px;
	background: ${colours.red};
	border-radius: 9px;
`;

export const LiveText = styled.div`
	${satoshi700}
	color: ${colours.red};
	font-size: 1.5rem;
`;
